import React, { useState, useEffect } from 'react';
import { Col, Row } from 'reactstrap';

//Api
import cep_api from '../../../../api/cep_api';

//Components
import TextField from '../../../../components/TextField';
import CustomMap from '../../../../components/CustomMap';

//Helpers
import { showMessage } from '../../../../helpers/message';
import mascaras from '../../../../helpers/mascaras';

//Context
import { useAuth } from '../../../../context/auth';

//Api
import tipoCompensacao_api from '../../../../api/tipoCompensacao_api';

// import { Container } from './styles';

function LocalSupressao({ requerimento, setRequerimento, errors }) {
  const { setLoading } = useAuth();

  //OnBlur do campo de cep
  const onBlurCep = (e) => {
    const { value } = e.target;
    const _cep = mascaras.cepMask(value, true);

    if (_cep.length === 8) {
      setLoading(true);
      cep_api.get(_cep).then(response => {

        const _requerimento = {
          ...requerimento,
          uf: response.data.uf,
          cidade: response.data.localidade,
          bairro: response.data.bairro,
          logradouro: response.data.logradouro,
          complemento: response.data.complemento
        };

        const endereco = {
          Cep: _requerimento.cep,
          Bairro: _requerimento.bairro,
          Logradouro: _requerimento.logradouro,
          Cidade: _requerimento.cidade,
          Estado: _requerimento.estado,
          Numero: _requerimento.numero,
          Latitude: "",
          Longitude: "",
          EnderecoFormatado: "",
        }
        cep_api.GeoCode(endereco).then(response => {
          if (response.data.latitude && response.data.longitude) {
            _requerimento.latitude = parseFloat(response.data.latitude.replace(",", "."));
            _requerimento.longitude = parseFloat(response.data.longitude.replace(",", "."));
          }
          setRequerimento(_requerimento);
        }).catch(e => {
          showMessage("Aviso", e.message, "error");
        }).finally(f => setLoading(false));
      })
        .catch(e => showMessage("Error", e.Message, "error", null))
    }
  }

  //onChange para o marker no mapa
  const onChangeLocation = (location) => {
    setRequerimento({ ...requerimento, latitude: location.lat, longitude: location.lng })
  }

  //onChange dos campos do local de supressão
  const onChange = (e) => {
    const { name, value } = e.target;

    setRequerimento({
      ...requerimento,
      [name]: value
    })
  }


  return <>
    <Row className='mx-4'>
      <Col md="12" lg="12">
        <h6 style={{ color: "#666" }}>Preencha os dados do local de supressão</h6>
      </Col>
      <Col md="12" lg="2">
        <TextField
          label={<><span>*</span>CEP</>}
          mask={mascaras.cepMask}
          maxLength={9}
          onBlur={onBlurCep}
          name={"cep"}
          type={"text"}
          value={requerimento.cep}
          invalid={!!errors.cep}
          onChange={onChange}
        />
      </Col>
      <Col md="12" lg="2">
        <TextField
          label={<><span>*</span>UF</>}
          name={"uf"}
          type={"text"}
          maxLength={2}
          value={requerimento.uf}
          invalid={!!errors.uf}
          onChange={onChange}
        />
      </Col>
      <Col md="12" lg="3">
        <TextField
          label={<><span>*</span>Cidade</>}
          name={"cidade"}
          type={"text"}
          value={requerimento.cidade}
          invalid={!!errors.cidade}
          onChange={onChange}
          maxLength={100}
        />
      </Col>
      <Col md="12" lg="5">
        <TextField
          label={<>Número do Processo Construtivo do Imóvel</>}
          name={"processoConstrutivoImovel"}
          type={"text"}
          value={requerimento.processoConstrutivoImovel}
          invalid={!!errors.processoConstrutivoImovel}
          onChange={onChange}
          maxLength={30}
        />
      </Col>
      <Col md="12" lg="5">
        <TextField
          label={<><span>*</span>Bairro</>}
          name={"bairro"}
          type={"text"}
          value={requerimento.bairro}
          invalid={!!errors.bairro}
          onChange={onChange}
          maxLength={100}
        />
      </Col>
      <Col md="12" lg="7">
        <TextField
          label={<><span>*</span>Logradoudo</>}
          name={"logradouro"}
          type={"text"}
          value={requerimento.logradouro}
          invalid={!!errors.logradouro}
          onChange={onChange}
          maxLength={100}
        />
      </Col>
      <Col md="12" lg="2">
        <TextField
          label={<><span>*</span>Numero</>}
          name={"numero"}
          type={"text"}
          value={requerimento.numero}
          invalid={!!errors.numero}
          onChange={onChange}
          mask={mascaras.numeroMask}
          maxLength={10}
        />
      </Col>

      <Col md="12" lg="6">
        <TextField
          label={"Complemento"}
          name={"complemento"}
          type={"text"}
          value={requerimento.complemento}
          onChange={onChange}
          maxLength={30}
        />
      </Col>
      <Col md="12" lg="4">
        <TextField
          label={"*Quantidade de árvores"}
          name={"quantidadeItens"}
          type={"number"}
          value={requerimento.quantidadeItens}
          invalid={!!errors.quantidadeItens}
          mask={mascaras.numeroMask}
          onChange={onChange}
        />
      </Col>
      <Col md="12" lg="12">
        <TextField
          label={<><span>*</span>Motivo da solicitação</>}
          name={"motivoSolicitacao"}
          type={"text"}
          value={requerimento.motivoSolicitacao}
          invalid={!!errors.motivoSolicitacao}
          onChange={onChange}
        />
      </Col>
    </Row>
    <Row className='mx-4 mb-3' style={{ height: "250px" }}>
      <Col md="12" lg="12" className='rounded overflow-hidden p-0' style={{ zIndex: 0 }}>
        <CustomMap
          markers={requerimento.latitude != '' && requerimento.longitude != '' ? [{ coordenadas: [requerimento.latitude ?? "", requerimento.longitude ?? ""] }] : null}
          addNewMarker
          positionCenter
          setPosition={onChangeLocation}
        />
      </Col>
    </Row>
  </>
}

export default LocalSupressao;